import React, { useCallback, useState } from 'react';
import ConfirmModal from '../components/ConfirmModal';

// Imperative front-end for ConfirmModal, for components with several
// destructive actions: `confirm({ message, confirmLabel, onConfirm, danger })`
// opens the dialog, and `confirmEl` has to be rendered somewhere in the tree
// - somewhere NOT inside a positioned box (.glass, .VoicePanel...), since
// Modal centers itself against the nearest positioned ancestor.
export function useConfirm() {
  const [pending, setPending] = useState(null);
  const confirm = useCallback((opts) => setPending(opts), []);
  const confirmEl = (
    <ConfirmModal
      open={!!pending}
      message={pending ? pending.message : ''}
      confirmLabel={pending ? pending.confirmLabel : ''}
      danger={pending ? pending.danger !== false : true}
      onCancel={() => setPending(null)}
      onConfirm={() => {
        const p = pending;
        setPending(null);
        if (p) p.onConfirm();
      }}
    />
  );
  return [confirm, confirmEl];
}
